<template>
  <div>
    <v-toolbar
      collapse
      class="d-print-none"
    >
      <v-btn
        icon
        @click="goBack"
      >
        <v-icon large>
          chevron_left
        </v-icon>
      </v-btn>
      <template>
        <v-menu
          offset-y
        >
          <template
            v-slot:activator="{ on }"
          >
            <v-btn
              icon
              v-on="on"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list class="d-print-none">
            <v-list-item @click="print">
              <v-list-item-action>
                <v-icon>print</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="`Imprimir`" />
            </v-list-item>
            <v-list-item
              @click="toggleChart"
              v-if="$route.meta.isChart"
            >
              <v-list-item-action>
                <v-icon
                  :color="(openChart) ? 'primary' : 'secondary'"
                  v-html="(openChart) ? 'check_box' : 'check_box_outline_blank'"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Gráfico</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="toggleTable">
              <v-list-item-action>
                <v-icon
                  :color="(tableDense) ? 'primary' : 'secondary'"
                  v-html="(tableDense) ? 'check_box' : 'check_box_outline_blank'"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Tabela densa</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="toggleZeroValue"
              v-if="$route.meta.isOpcionalValue"
            >
              <v-list-item-action>
                <v-icon
                  :color="(zeroValue) ? 'primary' : 'secondary'"
                  v-html="(zeroValue) ? 'check_box' : 'check_box_outline_blank'"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Exibir registros opcionais</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <div v-if="Array.isArray($route.meta.exportableTable)">
              <v-list-item
                @click="exportTable(item)"
                v-for="(item, i) in $route.meta.exportableTable"
                :key="i"
              >
                <v-list-item-action>
                  <v-icon
                    color="secondary"
                    v-html="'file_download'"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name" />
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>
        </v-menu>
      </template>
    </v-toolbar>
    <v-container
      grid-list-xs
      fluid
    >
      <slot />
    </v-container>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'AppReport',
  computed: {
    ...mapGetters(['openChart', 'tableDense', 'zeroValue'])
  },
  methods: {
    ...mapMutations(['toggleChart', 'toggleTable', 'toggleZeroValue']),
    goBack () {
      this.$router.go(-1)
    },
    print () {
      window.print()
    },
    exportTable ({ index, filename }) {
      const config = { raw: true, type: 'string' }
      const tables = document.getElementsByTagName('table')
      if (tables[index] === null || tables[index] === undefined) {
        return alert('Index inválido')
      }
      const tableToDownload = tables[index]
      console.log(tableToDownload)
      const ws = XLSX.utils.table_to_sheet(tableToDownload, config)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, filename)
      return XLSX.writeFile(wb, `${this.$options.filters.dateToFile()}-${filename}.xlsx`)
    }
  }
}
</script>
